export const phoneMask = rawPhone => {
	if (rawPhone !== null) {
		return rawPhone
		.replace(/(\D)/g, '') 
		.replace(/(\d{1,2})(\d{0,5})(\d{3,4})/, '($1) $2-$3')
		.replace(/(-\d{4})\d+?$/, '$1' )
	}
}